export default {
	title: 'Indicadores',
	url: 'indicadores',
	subtitle:
		"Enumere sus indicadores de éxito y organícelos por categorías — por defecto, las 4 perspectivas del Balanced Scorecard: Financiera, Clientes, Procesos internos, Aprendizaje y crecimiento. La pestaña Visualización los presenta como un cuadro de mando integral, con su evolución por escenario.",
	no_description: 'Sin indicador definido',
	context_worse: 'Negativo',
	context_best: 'Positivo',
	tabs: {
		filters: {
			title: 'Filtros de vista'
		},
		general: {
			title: 'General'
		},
		export: {
			title: 'Exportar'
		},
		comments: {
			title: 'Historial'
		},
		bot: {
			title: 'IA'
		}
	},
	messages: {
		edit_constraint: 'Edición de indicador',
		create_constraint: 'Crear un nuevo indicador'
	},
	onboarding: {
		title: 'Revisión de los indicadores',
		description:
			"Verifique que los indicadores cubran las categorías del Balanced Scorecard y estén vinculados al plan de acción."
	}
};
